import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from "react-router-dom";

interface DetailsSidebarKeyValueProps {
  label: string;
  value?: string | null;
  valueClassName?: string;
  showWhenEmpty?: boolean;
  emptyText?: string;
  onClick?: () => void;
  isClickable?: boolean;
  to?: string | { pathname: string; search?: string };
}

const DetailsSidebarKeyValue: React.FC<DetailsSidebarKeyValueProps> = ({
  label,
  value,
  valueClassName = "text-sm text-stone-900",
  showWhenEmpty = false,
                                                                         emptyText,
  onClick,
                                                                         isClickable = false,
                                                                         to
}) => {
  const {t} = useTranslation();
  const actualEmptyText = emptyText || t('details.notSpecified');
  // Don't render if value is empty and showWhenEmpty is false
  if (!value && !showWhenEmpty) {
    return null;
  }

  const displayValue = value || actualEmptyText;
  const clickableClass = (isClickable || to) ? "cursor-pointer hover:underline" : "";
  const finalValueClassName = `text-right ${valueClassName} ${clickableClass}`;

  const renderValue = () => {
    if (to && isClickable) {
      return (
        <Link
          className={finalValueClassName}
          to={to}
          onClick={onClick}
        >
          {displayValue}
        </Link>
      );
    }

    return (
      <span
        className={finalValueClassName}
        onClick={isClickable ? onClick : undefined}
      >
        {displayValue}
      </span>
    );
  };

  return (
    <div className="flex justify-between gap-2">
      <span className="text-sm font-medium text-stone-500">{label}</span>
      {renderValue()}
    </div>
  );
};

export default DetailsSidebarKeyValue;
